var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapisEditarCinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5084 1.45108C11.964 0.995471 12.7027 0.995473 13.1583 1.45108L14.8822 3.17494C15.3378 3.63055 15.3378 4.36925 14.8822 4.82486L13.0202 6.68679L13.0119 6.69491L5.7932 13.5855C5.66132 13.7114 5.50176 13.8046 5.32734 13.8577L1.64559 14.9782C1.46894 15.032 1.27703 14.984 1.14646 14.8535C1.01589 14.7229 0.967911 14.531 1.02168 14.3543L2.13741 10.6883C2.19584 10.4963 2.30281 10.3227 2.44798 10.1841L9.65057 3.3089L11.5084 1.45108ZM9.99189 4.36555L3.13845 10.9075C3.11771 10.9273 3.10243 10.9521 3.09408 10.9795L2.25131 13.7486L5.03618 12.901C5.06109 12.8934 5.08389 12.8801 5.10273 12.8621L11.9513 6.32492L9.99189 4.36555ZM12.6667 5.62613L14.1751 4.11775C14.2401 4.05266 14.2401 3.94714 14.1751 3.88205L12.4512 2.15819C12.3861 2.0931 12.2806 2.0931 12.2155 2.15819L10.7071 3.66657L12.6667 5.62613Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapisEditarCinza);
export default __webpack_public_path__ + "static/media/lapisEditarCinza.39d244db3344076dabc5a89d7ce6bb94.svg";
export { ForwardRef as ReactComponent };